/**
 * This function creates a file from a URL.
 * @param url
 * @param fileName
 * @param contentType
 * @returns
 */
export async function createFile(url: string, fileName: string, contentType: string) {
	try {
		const response = await fetch(url);
		const blob = await response.blob();
		return new File([blob], fileName, { type: contentType || blob.type });
	} catch (error) {
		console.error(error);
		return null;
	}
}

/**
 * This function creates a file from a Blob.
 * It is useful for creating files from binary data, such as images or PDFs.
 * @param blob
 * @param fileName
 * @param contentType
 * @returns
 */
export async function createFileFromBlob(blob: Blob, fileName: string, contentType: string) {
	try {
		return new File([blob], fileName, { type: contentType });
	} catch (error) {
		console.error(error);
		return null;
	}
}

/**
 * This function creates a file from a buffer.
 * It is useful for creating files from binary data, such as images or PDFs.
 * @param buffer
 * @param fileName
 * @param contentType
 * @returns
 */
export async function createFileFromBuffer(buffer: Buffer, fileName: string, contentType: string) {
	try {
		return new File([buffer as BlobPart], fileName, { type: contentType });
	} catch (error) {
		console.error(error);
		return null;
	}
}
